import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Inizializza SocialLogin il prima possibile: nella popup OAuth di Google il
// plugin web deve istanziarsi PRIMA che il parent rilevi popup.closed,
// altrimenti il login web fallisce con "Popup closed".
SocialLogin.initialize({
  google: {
    webClientId: environment.webClientId,
    iOSClientId: environment.iOSClientId,
    mode: 'online',
  },
  facebook: {
    appId: environment.facebookAppId,
    clientToken: environment.facebookClientToken,
  },
}).catch((err) => console.error('SocialLogin.initialize failed', err));

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.log(err));
